import type { SelectOption } from 'ui/select/select';

import {
  type AnimationSettingResult,
  AnimationSettingsDialog,
  type View
} from 'cadenza/conditions/actions/animation-settings-dialog';
import {
  TableSliderAnimationPreview
} from 'cadenza/conditions/table-slider-condition/table-slider-animation-preview';
import type {
  WorkbookTableConditionApi
} from 'cadenza/api-client/workbook-conditions/workbook-table-condition-api';
import type { TableColumnsDto } from 'cadenza/workbook/model/workbook-interaction-dtos';

import i18n from './table-slider-animation-settings-dialog.properties';

const COMPONENT_NAME = 'd-table-slider-animation-settings-dialog';

export class TableSliderAnimationSettingsDialog extends AnimationSettingsDialog {

  _rangeStart: SelectOption;
  _rangeEnd: SelectOption;
  _selectedStart: SelectOption;
  _maxFrames: number;
  _conditionApi: WorkbookTableConditionApi;
  _tableColumnsDef: TableColumnsDto;

  _preview: TableSliderAnimationPreview;

  constructor (
    affectedViews: View[],
    rangeStart: SelectOption,
    rangeEnd: SelectOption,
    selectedStart: SelectOption,
    maxFrames: number,
    conditionApi: WorkbookTableConditionApi,
    tableColumnsDef: TableColumnsDto) {
    super(affectedViews);
    this._rangeStart = rangeStart;
    this._rangeEnd = rangeEnd;
    this._selectedStart = selectedStart;
    this._maxFrames = maxFrames;
    this._conditionApi = conditionApi;
    this._tableColumnsDef = tableColumnsDef;

    this._preview = this._createPreview();
    this.setLoading(this._preview.dataLoadingPromise, { label: i18n('loadingData') });
  }

  createSpecificContent (): HTMLElement[] {
    return [ this._preview ];
  }

  _createPreview (): TableSliderAnimationPreview {
    return new TableSliderAnimationPreview(
      this._selectedStart,
      this._rangeEnd,
      this._maxFrames,
      this._conditionApi,
      this._tableColumnsDef);
  }

  onSubmit (event: SubmitEvent) {
    const result: AnimationSettingResult = {
      type: 'table',
      viewId: this._viewSelect?.selection[0].id,
      rangeStart: this._preview.startIndex,
      rangeEnd: this._preview.endIndex,
      sliderRangeStart: this._rangeStart,
      sliderRangeEnd: this._rangeEnd
    };
    this.close(result);
  }

}

customElements.define(COMPONENT_NAME, TableSliderAnimationSettingsDialog);
